/**
 * Persist live-preview side panel pin state in localStorage.
 */

import { useCallback, useState } from 'react';

const STORAGE_KEY = 'flow-optimizer-preview-panel-pinned';

function readPinned(): boolean {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw === 'false') return false;
    if (raw === 'true') return true;
  } catch {
    /* ignore */
  }
  return true;
}

function writePinned(next: boolean): void {
  try {
    localStorage.setItem(STORAGE_KEY, String(next));
  } catch {
    /* ignore */
  }
}

export function usePreviewPanelPin() {
  const [pinned, setPinnedState] = useState(readPinned);

  const setPinned = useCallback((next: boolean) => {
    setPinnedState(next);
    writePinned(next);
  }, []);

  const togglePinned = useCallback(() => {
    setPinnedState((prev) => {
      const next = !prev;
      writePinned(next);
      return next;
    });
  }, []);

  return { pinned, setPinned, togglePinned };
}
